export default {


    /**
     * Get requests count
     * @param state
     * @returns {default.campaigns|{}}
     */
    getAjaxRequestsCount: state => {
        // Return ajax requests count
        return state.ajaxRequestsCount;
    },


    /**
     * Get var
     * @param state
     * @returns {default.campaigns|{}}
     */
    getVar: state => (vn) => {
        // Return ajax requests count
        return state.vars[vn];
    },

    /**
     * Get months list
     */

    getMonths: state =>
    {
        // Return state
        return state.months;
    },

    /**
     * Get days list
     */

    getDays: state =>
    {
        // Return state
        return state.days;
    },

    /**
     * Get last update
     * @returns {number}
     */
    getLastUpdateTime: state => {

        // Get las ttime
        return state.lastUpdateTime ? state.lastUpdateTime : 0;
    }
}
